import React from "react";

import { useTranslation } from "react-i18next";

import type { Scores } from "@local-logic/client";
import { ScoreIconDeprecated } from "~/components/ScoreIconDeprecated";

import * as styles from "./styles";

export const Item = ({ score }: { score: keyof Scores["location"] }) => {
  const { t } = useTranslation(["neighborhoodHighlights", "common"]);

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <div className={styles.iconContent}>
          <ScoreIconDeprecated score={score} className={styles.icon} />
        </div>
      </div>
      <div>
        <p className={styles.highlightText}>{t("highlight.title")}</p>
        <p className={styles.highlightPill}>
          {t(`common:scores.${score}.titleDeprecated`)}
        </p>
      </div>
    </div>
  );
};
